import { useEffect, useRef } from 'react'

const useOutsideClick = (handler: () => void) => {
    const domNode = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        const maybeHandler = (event: Event) => {
            if (!domNode.current?.contains(event.target as Node)) {
                handler()
            }
        }

        document.addEventListener('mousedown', maybeHandler)

        return () => {
            document.removeEventListener('mousedown', maybeHandler)
        }
    })

    return domNode
}

export default useOutsideClick
